import React, { useState } from "react";
import Table from "../../../../Shared/Table";
import Chip from "../../../../Shared/StatusChip";
import DeleteApiBtn from "../GeneralSettings/DeleteApiBtn";
import { PrimaryButton } from "src/Shared/Buttons";
import { useDispatch } from "react-redux";
import { licenseApiKeysActions } from "src/Store/Reducers/LicenseApiKeys-reducer";
import {
  Box,
  TextField,
  Button,
  DialogActions,
  FormGroup,
  DialogContent,
  DialogTitle,
  Dialog,
  CircularProgress,
  MenuItem,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import axios from "axios";
import { useParams } from "react-router-dom";
import InfoIcon from "@material-ui/icons/Info";
import { withStyles } from "@material-ui/styles";
const RestaurantLicenseApiKeysComp = ({
  classes,
  settings,
  setSettings,
  loading,
  handleSnackbarOpen,
}) => {
  let initalFormData = {
    api_key_name: "",
    id: "",
    type: "",
  };
  let errorObj = {
    error: false,
    message: "",
  };
  let apiKeys = settings?.generalSettings?.licence_api_keys;
  const [isOpen, setIsOpen] = useState(false);
  const [isError, setIsError] = useState({
    api_key_name: errorObj,
    id: errorObj,
    type: errorObj,
  });
  const [formData, setFormData] = useState(initalFormData);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const { id } = useParams();
  const dispatch = useDispatch();

  const getTime = (time) => {
    let key = parseInt(time);
    return (
      new Date(key).toDateString() +
      " " +
      new Date(key).getHours() +
      ":" +
      new Date(key).getMinutes() +
      ":" +
      new Date(key).getSeconds()
    );
  };
  const formValidator = (name, value) => {
    let lengthRegex = /^.{1,70}$/;
    let idRegex = /\s/g;
    let typeRegex = /DEVICE_ID/g;
    switch (name) {
      case "api_key_name":
        if (!lengthRegex.test(value)) {
          setIsError({
            ...isError,
            [name]: { error: true, message: "Invalid Api Key Name!" },
          });
          return true;
        } else {
          setIsError({
            ...isError,
            [name]: { error: false, message: "" },
          });
          return false;
        }
      case "id":
        if (idRegex.test(value) || !lengthRegex.test(value)) {
          setIsError({
            ...isError,
            [name]: {
              error: true,
              message: "Invalid Id!",
            },
          });
          return true;
        } else {
          setIsError({
            ...isError,
            [name]: { error: false, message: "" },
          });
          return false;
        }
      case "type":
        if (!typeRegex.test(value) || !lengthRegex.test(value)) {
          setIsError({
            ...isError,
            [name]: { error: true, message: "Invalid Type!" },
          });
          return true;
        } else {
          setIsError({
            ...isError,
            [name]: { error: false, message: "" },
          });
          return false;
        }
      default:
        break;
    }
  };

  const handleChange = async (e, index) => {
    const { name, value } = e.target;

    formValidator(name, value);
    if (typeof index == "number") {
      let settingsObj = settings;
      let newobj = settingsObj.generalSettings.licence_api_keys[index];
      newobj[name] = value;
      // setSettings({...newobj})
      let obj = settings.generalSettings.licence_api_keys[index];
      setFormData({ ...obj, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const deleteApiKeyHandler = async (apikey, index) => {
    setBtnLoading(true);
    const tempObj = settings?.generalSettings;
    let toDeleteApiKey = tempObj?.licence_api_keys?.find((_, i) => i == index);
    if (
      typeof toDeleteApiKey === "object" &&
      Object.keys(toDeleteApiKey).length > 0
    ) {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}delete/apikey/${id}`,
          {
            api_key: toDeleteApiKey.api_key,
            created: toDeleteApiKey.created,
          }
        );
        if (res.data) {
          let finalLicenceApiKeys = tempObj?.licence_api_keys?.filter(
            (_, i) => i != index
          );
          tempObj.licence_api_keys = finalLicenceApiKeys;
          setSettings({ ...settings, generalSettings: tempObj });
          // updating redux
          dispatch(
            licenseApiKeysActions.deleteApiKey({
              api_key: toDeleteApiKey.api_key,
            })
          );
          handleSnackbarOpen("API key deleted successfully", "successDark");
        } else {
          handleSnackbarOpen("Something went wrong!", "errorDark");
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          handleSnackbarOpen(error.response.data.error, "errorDark");
        } else {
          handleSnackbarOpen(error.message, "errorDark");
        }
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const validator = () => {
    let data = formData;
    for (let i in data) {
      let res = formValidator(i, data[i]);
      if (res === true) {
        return false;
      }
    }
    return true;
  };

  const addApiKeyHandler = async (event) => {
    event.preventDefault();
    if (validator() === false) {
      handleSnackbarOpen("Invalid Inputs", "errorDark");
      return;
    }
    try {
      setBtnLoading(true);
      setBtnDisabled(true);
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}apikey/${id}`,
        {
          ...formData,
        }
      );
      if (data) {
        // adding data in redux
        let apiKey1 = {
          api_key: data.data.api_key,
          api_key_name: formData.api_key_name,
          status: "APPROVED",
          id_type: formData.type,
          created: data.data.created,
          id: formData.id,
          restaurant_id: id,
          restaurant_name:
            settings?.generalSettings?.basic?.restaurant_name || "",
        };
        let apiKey2 = {
          api_key: data.data.api_key,
          api_key_name: formData.api_key_name,
          status: "APPROVED",
          kind: "LICENSE",
          created: data.data.created,
          id: formData.id,
          restaurant_id: id,
          type: formData.type,
        };
        dispatch(licenseApiKeysActions.addApiKey(apiKey1));
        const tempObj = settings?.generalSettings;
        let finalLicenceApiKeys = [
          apiKey2,
          ...settings.generalSettings.licence_api_keys,
        ];
        finalLicenceApiKeys = finalLicenceApiKeys.flat();
        tempObj.licence_api_keys = finalLicenceApiKeys;
        setSettings({ ...settings, generalSettings: tempObj });
        handleSnackbarOpen("API key added successfully", "successDark");
      } else {
        handleSnackbarOpen("Something went wrong!", "errorDark");
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        handleSnackbarOpen(error?.response?.data?.error, "errorDark");
        return;
      }
      if (error.message) {
        handleSnackbarOpen(error?.message, "errorDark");
        return;
      }
    } finally {
      setBtnDisabled(false);
      setBtnLoading(false);
      setIsOpen(false);
      setFormData(initalFormData);
    }
  };

  const closeAddApiKeyHandler = () => {
    setIsOpen(false);
    setIsError({
      api_key_name: errorObj,
      id: errorObj,
      type: errorObj,
    });
    setFormData(initalFormData);
  };
  const updateApiKeyStatusUpdate = (index, status) => {
    const tempObj = settings?.generalSettings;
    let finalLicenceApiKeys = settings.generalSettings.licence_api_keys.map(
      (item, i) => {
        if (i === index) {
          item.status = status;
          return item;
        } else {
          return item;
        }
      }
    );
    tempObj.licence_api_keys = finalLicenceApiKeys;
    setSettings({ ...settings, generalSettings: tempObj });
  };

  const formatData = (data) => {
    let formattedData = data.map((item, index) => ({
      api_key_name: item.api_key_name || "—",
      id: item?.id || "—",
      id_type: item?.type || "—",
      created_at: item.created ? getTime(item.created) : "—",
      api_key_status: item?.status ? (
        <Chip
          index={index}
          setLoading={() => {}}
          handleSnackbarOpen={handleSnackbarOpen}
          isLoading={loading}
          data={apiKeys}
          comp="license"
          statusKey="status"
          itemId={item?.api_key}
          handleApiKeyStatus={updateApiKeyStatusUpdate}
        />
      ) : (
        "—"
      ),
      api_key_action: item?.api_key ? (
        <DeleteApiBtn
          apiKey={item.api_key}
          handleAPIKeyDelete={deleteApiKeyHandler}
          classes={classes}
          parentIndex={index}
        />
      ) : (
        "—"
      ),
    }));
    return formattedData;
  };
  const columns = [
    {
      name: "api_key_name",
      label: "Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "id",
      label: "Id",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "id_type",
      label: "Id Type",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "created_at",
      label: "Created At",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "api_key_status",
      label: "Status",
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: "api_key_action",
      label: "Action",
      options: {
        sort: false,
        filter: false,
      },
    },
  ];
  const endPoints = [
    {
      key: "Register License API :",
      endPoint: `pos/restaurant/license/apikey`,
    },
    {
      key: "Get License Status API :",
      endPoint: `pos/restaurant/license/data/apikey?device_id={device_id}`,
    },
    {
      key: "Write POS data API :",
      endPoint: `pos/restaurant/license/data`,
    },
    {
      key: "Read POS data API :",
      endPoint: `pos/restaurant/license/data/fetch?key={key}`,
    },
  ];
  let arr = [];
  endPoints.forEach((item) => {
    arr.push(`${item.key}\n${item.endPoint}`);
  });
  let finalData = arr.join("\n\n");
  const DarkToolTip = withStyles((theme) => ({
    tooltip: {
      fontSize: 18,
      minWidth: 550,
    },
  }))(Tooltip);
  const onTableChangeHandler = (action, tableState) => {};
  return (
    <>
      <Box>
        <Box className={classes.addLicenseBtnContainer}>
          <DarkToolTip
            title={
              <div
                style={{
                  whiteSpace: "pre-line",
                  color: "#CCC",
                  fontSize: "18px",
                  margin: "5px",
                }}
              >
                {finalData}
              </div>
            }
            interactive
            placement="bottom"
          >
            <IconButton aria-label="endpoints">
              <InfoIcon />
            </IconButton>
          </DarkToolTip>
          <PrimaryButton handleClick={() => setIsOpen(true)}>
            Add License Key
          </PrimaryButton>
        </Box>
        <Table
          data={formatData(apiKeys)}
          columns={columns}
          title="License Apikeys"
          onTableChange={onTableChangeHandler}
        />
      </Box>
      {isOpen && (
        <Dialog
          maxWidth="xs"
          fullWidth
          open={isOpen}
          onClose={closeAddApiKeyHandler}
        >
          <form>
            <DialogTitle className={classes.typographyStyles}>
              Add License Api key
            </DialogTitle>
            <DialogContent>
              <FormGroup>
                <TextField
                  type="text"
                  label="API key name"
                  margin="dense"
                  size="medium"
                  name="api_key_name"
                  value={formData.api_key_name}
                  error={isError.api_key_name.error}
                  helperText={
                    isError.api_key_name.error && isError.api_key_name.message
                  }
                  onChange={handleChange}
                  inputProps={{
                    "aria-label": "licence_api_key_name_input",
                  }}
                />
                <TextField
                  type="text"
                  label="Id"
                  name="id"
                  size="medium"
                  value={formData.id}
                  margin="dense"
                  error={isError.id.error}
                  helperText={isError.id.error && isError.id.message}
                  onChange={handleChange}
                  inputProps={{
                    "aria-label": "licence_id_input",
                  }}
                />
                <TextField
                  label="Api Type"
                  select
                  size="medium"
                  margin="dense"
                  value={formData.type}
                  onChange={handleChange}
                  name="type"
                  error={isError.type.error}
                  helperText={isError.type.error && isError.type.message}
                >
                  <MenuItem value={"DEVICE_ID"}>DEVICE_ID</MenuItem>
                </TextField>
              </FormGroup>
            </DialogContent>
            <DialogActions>
              <Button
                variant="text"
                style={{ color: "#09c491" }}
                onClick={closeAddApiKeyHandler}
                data-testid="cancel_add_licence_api_key_btn"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="text"
                style={{ color: "#09c491" }}
                onClick={addApiKeyHandler}
                data-testid="confirm_add_licence_api_key_btn"
                disabled={btnDisabled}
              >
                {btnLoading ? <CircularProgress size={21} /> : "ADD"}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      )}
    </>
  );
};

export default RestaurantLicenseApiKeysComp;
